import { Injectable } from '@angular/core';
import { DeliveryFormStateService } from '../../../form-state/delivery-form-state.service';

declare const google: any;

@Injectable()
export class MapAddressService {

  private geocoder: google.maps.Geocoder;
  private wasSearched: boolean = false;

  constructor(
    private deliveryFormStateService: DeliveryFormStateService,
  ) {
  }

  public positionFromRegisteredAddress(): Promise<any> {
    return new Promise<any>((_resolve: any, _reject: Function) => {
      let registeredAddress = this.deliveryFormStateService.outputState.valCorrespondenceAddressFormValuesForGoogleMaps;

      if (registeredAddress) {
        this.geocodeAddress({address: registeredAddress})
          .then((location: google.maps.LatLng) => {
            _reject({
              location: location,
              type: 'registeredAddressFromForm'
            });
          })
          .catch(() => {
            _resolve();
          });

        return;
      }

      _resolve();
    });
  }

  public positionFromBrowser(): Promise<any> {
    return new Promise<any>((_resolve: Function, _reject: Function) => {
      navigator.geolocation.getCurrentPosition((position: any) => {
          const location: google.maps.LatLng = new google.maps.LatLng(position.coords.latitude, position.coords.longitude);

          this.geocodeAddress({'location': location}, 'geolocationFromBrowser')
            .then(() => {
              if (!this.wasSearched) {
                _reject({
                  location: location,
                  type: 'geolocationFromBrowser'
                });
              }
            })
            .catch(() => {
              if (!this.wasSearched) {
                _resolve();
              }
            });
        },
        () => {
          if (!this.wasSearched) {
            _resolve();
          }
        });
    });
  }

  public positionFromDefaultAddress() {
    return new Promise<any>((_resolve: Function, _reject: Function) => {
      this.geocodeAddress({address: 'Warszawa'})
        .then(
          (location: google.maps.LatLng) => {
            _reject({
              location: location,
              type: 'positionFromDefaultAddress'
            });
          })
        .catch(() => {
          _reject();
        });
    });
  }

  public positionFromCustomAddress(address: string): Promise<any> {
    return new Promise<any>((_resolve: Function, _reject: Function) => {
      this.geocodeAddress({address: address})
        .then((location: google.maps.LatLng) => {
          this.wasSearched = true;

          _resolve({
            location: location,
            type: 'positionFromCustomAddress'
          });
        })
        .catch(() => {
          _reject();
        });
    });
  }

  private geocodeAddress(address: {address?: string, location?: google.maps.LatLng}, _type?: string): Promise<any> {
    this.geocoder = this.geocoder || new google.maps.Geocoder();

    const searchFor: google.maps.GeocoderRequest = Object.assign({}, address, {componentRestrictions: {country: 'PL'}});

    return new Promise<any>((_resolve: Function, _reject: Function) => {
      this.geocoder.geocode(searchFor, (response: any, status: any) => {
        if (
          _type === 'geolocationFromBrowser'
          && status === google.maps.GeocoderStatus.OK
          && this.isLocationInPoland(response[0].address_components)
        ) {
          _resolve(response[0].geometry.location);

          return;

        } else if (
          status === google.maps.GeocoderStatus.OK
          && this.isLocationInPoland(response[0].address_components)
          && this.fulfillsRestrictedTypes(response[0].types)
        ) {
          _resolve(response[0].geometry.location);

          return;
        }

        _reject();
      });
    });
  }

  private isLocationInPoland(arrayOfAddressComponents: any): boolean {
    return !!arrayOfAddressComponents.find((addressComponent: any) => addressComponent.short_name === 'PL');
  }

  private fulfillsRestrictedTypes(types: string[]) {
    const allowedTypes = ['street_address', 'postal_code', 'locality', 'route', 'premise'];

    return <boolean>!!types.find((type: string) => allowedTypes.indexOf(type) !== -1)
  }
}
